module.exports = __webpack_public_path__ + "img/research1.39ad1f7b.png";